import { getBackVersion } from '../../config';
import { decamelizeKeys } from '../../lib';
import { LandlordAreaWorkspaceSnapshot } from '../../models/LandlordArea';
import { RentalLandlordInput } from '../../models/RentalPayment';
import api from '../api';

const getWorkspace = (): Promise<LandlordAreaWorkspaceSnapshot> =>
    api.request<LandlordAreaWorkspaceSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/workspace`,
    });

const getLandlord = (): Promise<RentalLandlordInput> =>
    api.request<RentalLandlordInput>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area`,
    });

const tokenAccess = (token: string): Promise<RentalLandlordInput> =>
    api.request<RentalLandlordInput>({
        method: 'POST',
        url: `${getBackVersion()}/landlord_area/token_access`,
        data: { token },
    });

const newToken = (workspaceId: string, landlordId: number): Promise<void> =>
    api.request<void>({
        method: 'POST',
        url: `${getBackVersion()}/landlord_area/token_access/new`,
        data: decamelizeKeys({ workspaceId, landlordId }),
    });

export { getLandlord, getWorkspace, tokenAccess, newToken };
